import React, { useEffect } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function SimpleBackdrop(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(true);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    useEffect(() => {
        if (props.handleToggle) {
            handleToggle();
        }
        if (props.handleClose) {
            handleClose();
        }
    }, [])

    return (
        <div>
            {/* <Button variant="outlined" color="primary" onClick={handleToggle}>
        Show backdrop
      </Button> */}
            <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
                <CircularProgress color="primary" style={{ width: '100px', height: '100px' }} />
            </Backdrop>
        </div>
    );
}
